module.exports = __webpack_public_path__ + "img/zengzaikaoshi.02a7473e.png";